import React from 'react';
import { OrganizationSuggestionsResponse } from '../../../store/signup/types';
import toCamelCase from 'camelcase-keys';
import { RequestState, requestError, requestSuccess } from './useRequestState';
import { zipRegExp } from './validationRegExp';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import { textFieldWidth } from '../components/styles';
import { webConfig } from 'webConfig';

export const zipValidation = (value: string | undefined): boolean =>
    !!value && zipRegExp.test(value);

export const onMessage = (
    response: MessageEvent,
    setRequestState: React.Dispatch<
        React.SetStateAction<RequestState<OrganizationSuggestionsResponse[]>>
    >,
    limit?: number,
) => {
    const data = JSON.parse(response.data);
    if (data.status !== 'success') {
        setRequestState(requestError(new Error('Error loading suggestion')));
        return;
    }
    const results = toCamelCase(
        data.message.hits.slice(0, limit || webConfig.maxOrganizationResult),
        {
            deep: true,
        },
    ) as unknown as OrganizationSuggestionsResponse[];
    setRequestState(requestSuccess(results));
};

export const useOrganizationAutoCompleteStyles = makeStyles((theme: Theme) =>
    createStyles({
        gridStyles: {
            maxWidth: textFieldWidth,
            margin: '0 auto',
            '& .left': {
                paddingRight: theme.spacing(2),
            },
            '& .right': {
                paddingLeft: theme.spacing(2),
            },
            '& .text-field': {
                width: '100%',
            },
            [`@media (max-width:${textFieldWidth}px)`]: {
                width: '100%',
            },
            [theme.breakpoints.down('xs')]: {
                '& .left': {
                    paddingRight: 0,
                },
                '& .right': {
                    paddingLeft: 0,
                },
            },
        },
    }),
);
